import angular from 'angular'
import './channel_prize_banners.service'
import './edit/edit.controller'

angular
  .module('admin.channel_prize_banners', [
    'admin.channel_prize_banners.service',
    'admin.channel_prize_banners.edit',
  ])
  .controller('ChannelPrizeBannersCtrl', ChannelPrizeBannersCtrl)

/** @ngInject */
function ChannelPrizeBannersCtrl($state, $scope, $timeout, ChannelPrizeBannersService) {
  var vm = this
  vm.items = []

  vm.perPage = 25
  vm.sortType = 'ts-desc'
  vm.sortReverse = false

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.pagination = { current: 1 }
  }

  reloadPagination()
  loadAll(1)

  var oldSortType
  function loadAll(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * vm.perPage
      vm.oldPage = vm.currentPage - vm.perPage
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)

    ChannelPrizeBannersService.list(vm.oldPage, vm.perPage, vm.sortType, vm.search).then(
      function (result) {
        var banners = result.results || []
        if (vm.totalItems === 0 && result.ct) {
          vm.totalItems = result.ct
        }
        // add helpers
        banners.forEach((b, i) => {
          if (pageNumber === 1 && i === 0) b.firstRow = true
          if (i === banners.length - 1 && banners.length < vm.currentPage) b.lastRow = true
        })
        vm.sortType = oldSortType
        vm.items = banners
      },
    )
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadAll(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.add = () => $state.go('admin.channel_prize_banners.edit', { id: 0 })

  vm.delete = function (item) {
    swal({ title: 'Are you Sure?', type: 'warning', showCancelButton: true }, function (isConfirm) {
      if (isConfirm) {
        ChannelPrizeBannersService.remove(item.id).then(
          () => $state.reload(),
          () =>
            $timeout(
              () => swal("You can't delete because it has things associated", '', 'error'),
              750,
            ),
        )
      }
    })
  }

  vm.arrowUp = function (item) {
    if (item.edit) return
    ChannelPrizeBannersService.update(item.id, { n: item.n - 1 }).then(() => {
      loadAll(vm.pagination.current)
    })
  }

  vm.arrowDown = function (item) {
    if (item.edit) return
    ChannelPrizeBannersService.update(item.id, { n: item.n + 1 }).then(() => {
      loadAll(vm.pagination.current)
    })
  }

  vm.sort = function (type) {
    vm.sortReverse = !vm.sortReverse
    vm.sortType = type + (vm.sortReverse ? '-asc' : '-desc')
    loadAll(vm.pagination.current)
  }

  $scope.$on('$destroy', () => watch())
}
